import { normalizePlanName } from '@/common/constants/planNames';
import {
	getMailLinkKey,
	getPaymentBrowsingPersonId,
	getPaymentUtms,
	isQuizPaymentContext,
} from '@/common/functions/getUtms';

export const buildStripePlanPaymentPayload = ({ planName, user }) => {
	const mailLinkKey = getMailLinkKey();
	const browsingPerson = getPaymentBrowsingPersonId();
	const payload = {
		plan: normalizePlanName(planName),
		type: 'STRIPE',
		paymentFor: 'PLAN',
		paymentUtms: getPaymentUtms(),
		customerId: user?.id,
		customerEmail: user?.email,
		fromQuiz: isQuizPaymentContext(),
	};

	if (browsingPerson) {
		payload.browsingPerson = browsingPerson;
	}

	if (mailLinkKey) {
		payload.mailLinkKey = mailLinkKey;
	}

	return payload;
};
